// extracted by mini-css-extract-plugin
export var container = "_10h-0";